import { render, staticRenderFns } from "./ClientCredit.vue?vue&type=template&id=849cda88"
import script from "./ClientCredit.vue?vue&type=script&lang=js"
export * from "./ClientCredit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports